import {
  contentScoreWeights,
  countSentences,
  getContentlengthWithHeadings,
  wordCountHelper,
} from "./contentHelper";
import {
  computeCorrectScore,
  findMatches,
  getCounts,
  getFirstWords,
  getTags,
  getText,
} from "./helper";

// Word Count and Character Count Check
const wordCount = (formikProps, competitorResults) => {
  const text = getText(
    formikProps.values.h1_title.trim() +
      formikProps.values.introduction.trim() +
      formikProps.values.content.trim() +
      formikProps.values.conclusion.trim()
  );

  const counts = getCounts(text);
  if (counts.chars == 0) {
    return { score: -1, percentage: 0, words: 0, nb_words: 0 };
  }
  const nb_words = formikProps.values.nb_words;
  return wordCountHelper(counts.words, nb_words, competitorResults);
};

// Target Request Check
const targetRequestCheck = (formikProps) => {
  const text = getFirstWords(
    getText(
      formikProps.values.introduction.trim() +
        formikProps.values.content.trim() +
        formikProps.values.conclusion.trim()
    ),
    150
  );

  if (text.trim().length == 0) {
    return { score: -1 };
  }

  const seoRequest = getText(formikProps.values.seo_request.trim())
    .toLowerCase()
    .split(" ");

  let count = 0;
  seoRequest.forEach((word) => {
    const matches = findMatches(text, word);

    if (matches) {
      count += 1;
    }
  });
  if (count == 0) {
    return { score: 0 };
  }
  if (count > 0 && count < seoRequest.length) {
    return { score: 50 };
  }
  if (count >= seoRequest.length) {
    return { score: 100 };
  }
};

// Section Length Balance
const lengthBalanceCheck = (formikProps) => {
  const tags = getTags(formikProps.values.content.trim());
  if (tags.length == 0) {
    return { score: -1, tooLong: 0, tooShort: 0, validParts: 0 };
  }

  let validParts = 0;
  let tooLong = 0;
  let tooShort = 0;
  const sections = getContentlengthWithHeadings(tags);

  sections.forEach((item) => {
    const startTag = parseInt(item.startHeader.replace("h", ""), 10);
    const endTag = item.endHeader
      ? parseInt(item.endHeader.replace("h", ""), 10)
      : null;

    if (startTag == 2 && endTag > startTag) {
      if (item.contentLength >= 0 && item.contentLength <= 50) {
        validParts += 1;
      } else {
        tooLong += 1;
      }
    } else if (startTag == 2) {
      if (item.contentLength >= 100 && item.contentLength <= 400) {
        validParts += 1;
      } else {
        if (item.contentLength < 100) {
          tooShort += 1;
        }
        if (item.contentLength > 400) {
          tooLong += 1;
        }
      }
    }

    if (startTag == 3 && endTag > startTag) {
      if (item.contentLength >= 0 && item.contentLength <= 50) {
        validParts += 1;
      } else {
        tooLong += 1;
      }
    } else if (startTag == 3) {
      if (item.contentLength >= 100 && item.contentLength <= 400) {
        validParts += 1;
      } else {
        if (item.contentLength < 100) {
          tooShort += 1;
        }
        if (item.contentLength > 400) {
          tooLong += 1;
        }
      }
    }

    if (startTag == 4 && endTag >= startTag) {
      if (item.contentLength >= 0 && item.contentLength <= 50) {
        validParts += 1;
      } else {
        tooLong += 1;
      }
    } else if (startTag == 4) {
      if (item.contentLength >= 30 && item.contentLength <= 200) {
        validParts += 1;
      } else {
        if (item.contentLength < 30) {
          tooShort += 1;
        }
        if (item.contentLength > 200) {
          tooLong += 1;
        }
      }
    }
  });

  if (sections.length === 0) {
    tooShort = 0;
    tooLong = 0;
    validParts = 100;
  } else {
    tooShort = parseFloat(((tooShort / sections.length) * 100).toFixed(2));
    tooLong = parseFloat(((tooLong / sections.length) * 100).toFixed(2));
    validParts = parseFloat(((validParts / sections.length) * 100).toFixed(2));
  }

  if (tooLong > 30 || tooShort > 30) {
    return {
      score: 0,
      tooLong: tooLong,
      tooShort: tooShort,
      validParts: validParts,
    };
  }
  if ((tooLong >= 10 && tooLong <= 30) || (tooShort >= 10 && tooShort <= 30)) {
    return {
      score: 50,
      tooLong: tooLong,
      tooShort: tooShort,
      validParts: validParts,
    };
  }
  if (tooLong < 10 || tooShort < 10) {
    return {
      score: 100,
      tooLong: tooLong,
      tooShort: tooShort,
      validParts: validParts,
    };
  }
};

// Paragraph Density Check
const paragraphDensityCheck = (formikProps) => {
  const tags = getTags(
    formikProps.values.introduction.trim() +
      formikProps.values.content.trim() +
      formikProps.values.conclusion.trim()
  ).filter((item) => item.tag === "p");

  if (tags.length == 0) {
    return { score: -1, percentage: 0 };
  }

  let count = 0;
  tags.forEach((item) => {
    const counts = countSentences(item.content);
    if (counts > 6) {
      count += 1;
    }
  });

  const percentage = (count / tags.length) * 100;
  if (percentage > 50) {
    return { score: 0, percentage: parseFloat(percentage).toFixed() };
  }
  if (percentage >= 25 && percentage <= 50) {
    return { score: 50, percentage: parseFloat(percentage).toFixed() };
  }
  if (percentage < 25) {
    return { score: 100, percentage: parseFloat(percentage).toFixed() };
  }
};

// Presence of Introduction and Conclusion
const introPresenceCheck = (formikProps) => {
  const text = getText(
    formikProps.values.introduction.trim() +
      formikProps.values.content.trim() +
      formikProps.values.conclusion.trim()
  );
  if (text.length == 0) {
    return { score: -1, introLength: 0 };
  }
  if (
    getTags(formikProps.values.introduction).filter(
      (x) => !x.tag.toLowerCase().startsWith("h")
    ).length == 0 &&
    getTags(formikProps.values.conclusion).filter(
      (x) => !x.tag.toLowerCase().startsWith("h")
    ).length == 0
  ) {
    return {
      score: 0,
      introLength: getText(formikProps.values.introduction).length,
    };
  }
  if (
    getTags(formikProps.values.introduction).filter(
      (x) => !x.tag.toLowerCase().startsWith("h")
    ).length > 0 &&
    getTags(formikProps.values.conclusion).filter(
      (x) => !x.tag.toLowerCase().startsWith("h")
    ).length > 0
  ) {
    return {
      score: 100,
      introLength: getText(formikProps.values.introduction).length,
    };
  }
  if (
    getTags(formikProps.values.introduction).filter(
      (x) => !x.tag.toLowerCase().startsWith("h")
    ).length == 0 ||
    getTags(formikProps.values.conclusion).filter(
      (x) => !x.tag.toLowerCase().startsWith("h")
    ).length == 0
  ) {
    return {
      score: 20,
      introLength: getTags(formikProps.values.introduction).filter(
        (x) => !x.tag.toLowerCase().startsWith("h")
      ).length,
    };
  }
};

// Content Architecture
const contentArchitectureCheck = (formikProps) => {
  const tags = getTags(
    formikProps.values.introduction.trim() +
      formikProps.values.content.trim() +
      formikProps.values.conclusion.trim()
  ).filter((x) => !x.tag.includes("h"));

  if (tags.length == 0) {
    return {
      score: -1,
      percentage: -1,
      emphasis_percentage: 0,
      quotes_percentage: 0,
      tables_percentage: 0,
      listings_percentage: 0,
      text_percentage: 0,
    };
  }
  const wordCount = getCounts(
    getText(
      formikProps.values.introduction.trim() +
        formikProps.values.content.trim() +
        formikProps.values.conclusion.trim()
    )
  );
  const text = tags.filter((x) => x.tag === "p");
  const listings = tags.filter((x) => x.tag === "ul" || x.tag === "ol");
  const quotes = tags.filter((x) => x.tag === "blockquote");
  const tables = tags.filter((x) => x.tag === "table");
  const emphasis = tags
    .filter((x) => x.emphasis && x.emphasis.length > 0)
    .map((x) => x.emphasis)
    .flat();

  const text_percentage = parseFloat(
    ((text.length / tags.length) * 100).toFixed(2)
  );
  const listings_percentage = parseFloat(
    ((listings.length / tags.length) * 100).toFixed(2)
  );
  const quotes_percentage = parseFloat(
    ((quotes.length / tags.length) * 100).toFixed(2)
  );
  const tables_percentage = parseFloat(
    ((tables.length / tags.length) * 100).toFixed(2)
  );
  const emphasis_percentage = parseFloat(
    ((emphasis.length / wordCount.words) * 100).toFixed(2)
  );

  let red = 0;
  let green = 0;
  let yellow = 0;
  let score = [];
  if (text_percentage >= 40 && text_percentage <= 70) {
    green += 1;
    score.push(100);
  } else if (
    (text_percentage >= 35 && text_percentage < 40) ||
    (text_percentage > 70 && text_percentage <= 75)
  ) {
    yellow += 1;
    score.push(50);
  } else {
    red += 1;
    score.push(0);
  }
  if (listings_percentage >= 10 && listings_percentage <= 25) {
    green += 1;

    score.push(100);
  } else if (
    (listings_percentage >= 8 && listings_percentage < 10) ||
    (listings_percentage > 25 && listings_percentage <= 27)
  ) {
    yellow += 1;

    score.push(50);
  } else {
    red += 1;
    score.push(0);
  }
  if (tables_percentage >= 0 && tables_percentage <= 8) {
    green += 1;
    score.push(100);
  } else if (tables_percentage >= 9.5 && tables_percentage < 11) {
    yellow += 1;
    score.push(50);
  } else {
    red += 1;
    score.push(0);
  }

  if (quotes_percentage >= 0 && quotes_percentage <= 5) {
    green += 1;
    score.push(100);
  } else if (quotes_percentage >= 6 && quotes_percentage <= 7) {
    yellow += 1;
    score.push(50);
  } else {
    red += 1;
    score.push(0);
  }

  if (emphasis_percentage >= 0.5 && emphasis_percentage <= 2) {
    green += 1;
    score.push(100);
  } else if (
    (emphasis_percentage >= 0.25 && emphasis_percentage < 0.5) ||
    (emphasis_percentage > 2 && emphasis_percentage <= 2.25)
  ) {
    yellow += 1;

    score.push(50);
  } else {
    red += 1;
    score.push(0);
  }
  const totalScore = score.reduce((acc, num) => acc + num, 0) / score.length;
  if (red > 0) {
    return {
      score: 0,
      percentage: totalScore,
      emphasis_percentage: emphasis_percentage,
      quotes_percentage: quotes_percentage,
      tables_percentage: tables_percentage,
      listings_percentage: listings_percentage,
      text_percentage: text_percentage,
    };
  }
  if (yellow > 0 && red == 0) {
    return {
      score: 50,
      percentage: totalScore,
      emphasis_percentage: emphasis_percentage,
      quotes_percentage: quotes_percentage,
      tables_percentage: tables_percentage,
      listings_percentage: listings_percentage,
      text_percentage: text_percentage,
    };
  }
  if (green > 0 && yellow == 0 && red == 0) {
    return {
      score: 100,
      percentage: totalScore,
      emphasis_percentage: emphasis_percentage,
      quotes_percentage: quotes_percentage,
      tables_percentage: tables_percentage,
      listings_percentage: listings_percentage,
      text_percentage: text_percentage,
    };
  }
};

// Score Calculation
export const startContentAnalysis = (formikProps, competitorResults) => {
  const totalCount = wordCount(formikProps, competitorResults);
  const targetRequest = targetRequestCheck(formikProps);
  const lengthBalance = lengthBalanceCheck(formikProps);
  const paragraphDensity = paragraphDensityCheck(formikProps);
  const introPresence = introPresenceCheck(formikProps);
  const contentArchitecture = contentArchitectureCheck(formikProps);
  let totalScore = computeCorrectScore(
    [
      totalCount.score,
      targetRequest.score,
      lengthBalance.score,
      paragraphDensity.score,
      introPresence.score,
      contentArchitecture.percentage,
    ],
    contentScoreWeights
  );

  return {
    word_count: totalCount,
    target_request: targetRequest,
    length_balance: lengthBalance,
    paragraph_density: paragraphDensity,
    intro_presence: introPresence,
    content_architecture: contentArchitecture,
    total_score: Math.round(totalScore),
  };
};
